import React from "react";
import { useTranslation } from "react-i18next";

export type MatrixStatus = "yes" | "partial" | "no";

interface ComparisonTableProps {
  competitorName: string;
  capabilities: string[];
  axoixStatus: MatrixStatus[];
  axoixNote: string[];
  competitorStatus: MatrixStatus[];
  competitorNote: string[];
}

const STATUS_ICON: Record<MatrixStatus, string> = {
  yes: "fa-circle-check",
  partial: "fa-circle-minus",
  no: "fa-circle-xmark",
};

const STATUS_COLOR: Record<MatrixStatus, string> = {
  yes: "#00ff97",
  partial: "#f0b429",
  no: "#ff6b6b",
};

const StatusCell: React.FC<{ status: MatrixStatus; note: string }> = ({ status, note }) => {
  const { t } = useTranslation();
  const label = t(`common.${status}`, { defaultValue: status });
  return (
    <td className="comparison-table-cell">
      <span className="comparison-table-status" style={{ color: STATUS_COLOR[status] }}>
        <i className={`fas ${STATUS_ICON[status]} me-2`}></i>
        {label}
      </span>
      {note && note !== "–" && <div className="comparison-table-note">{note}</div>}
    </td>
  );
};

const ComparisonTable: React.FC<ComparisonTableProps> = ({
  competitorName,
  capabilities,
  axoixStatus,
  axoixNote,
  competitorStatus,
  competitorNote,
}) => {
  return (
    <div className="comparison-table-wrap">
      <table className="comparison-table">
        <thead>
          <tr>
            <th>Capability</th>
            <th>AXOIX</th>
            <th>{competitorName}</th>
          </tr>
        </thead>
        <tbody>
          {capabilities.map((capability, idx) => (
            <tr key={idx}>
              <th scope="row">{capability}</th>
              <StatusCell status={axoixStatus[idx]} note={axoixNote[idx]} />
              <StatusCell status={competitorStatus[idx]} note={competitorNote[idx]} />
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ComparisonTable;
